import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { PermitSearchModule } from '../../../titleregistration/search/permit/permit-search/permit-search.module';
import { PlateSearchModule } from '../../../titleregistration/search/plate/plate-search/plate-search.module';
import { RegistrationSearchModule } from '../../../titleregistration/search/registration/registration-search/registration-search.module';
import { VehicleGenericSearchModule } from '../../../titleregistration/search/vehicle-generic/vehicle-generic-search/vehicle-generic-search.module';
import { SharedPipesModule } from '../../pipes/shared-pipes.module';
import { ToggleSwitchComponent } from '../toggle-switch/toggle-switch.component';
import { ToggleSwitchModule } from '../toggle-switch/toggle-switch.module';
import { ValidationResultsModule } from '../validation-results/validation-results.module';
import { NavbarSearchComponent } from './navbar-search/navbar-search.component';
import { OmnisearchComponent } from './omnisearch/omnisearch.component';
import { SharedVehicleSearchResultsComponent } from './result-details/vehicle-search-results.component';
import { SearchCriteriaComponent } from './search-criteria/search-criteria.component';
import { SearchCriteriaService } from './search-criteria/search-criteria.service';
import { SearchResultService } from './search-results/search-result.service';
import { SearchResultsModalComponent } from './search-results/search-results-modal.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { VehicleGenericModalComponent } from './vehicle-generic-modal/vehicle-generic-modal.component';

@NgModule({
    declarations: [
        NavbarSearchComponent,
        OmnisearchComponent,
        SearchCriteriaComponent,
        SearchResultsComponent,
        SearchResultsModalComponent,
        SharedVehicleSearchResultsComponent,
        VehicleGenericModalComponent
    ],
    providers: [
        SearchCriteriaService,
        SearchResultService
    ],
    imports: [
        CommonModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        PanelModule,
        PermitSearchModule,
        PlateSearchModule,
        RegistrationSearchModule,
        SharedPipesModule,
        TableModule,
        ToggleSwitchModule,
        ValidationResultsModule,
        VehicleGenericSearchModule
    ],
    exports: [
        NavbarSearchComponent,
        OmnisearchComponent,
        SearchCriteriaComponent,
        SearchResultsComponent,
        SearchResultsModalComponent,
        SharedVehicleSearchResultsComponent,
        ToggleSwitchComponent
    ]
})
export class SearchModule {
}
